import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { BrandLabelRequest } from '@brand24-original/llm-types';
import { setBrandLabel } from '../../../../services/monitor/keywords/KeywordsService';
import {
  GET_ALL_COMMON_KEYWORDS,
  GET_COMMON_KEYWORDS,
  GET_PROJECT_KEYWORDS,
} from '../../../query/keyword/keys';

/**
 * Etykieta jest wyłącznie do wyświetlania, więc żadna statystyka nie wymaga przeliczenia — ale ekrany
 * biorą nazwę marki ze słownika marek (`GET_COMMON_KEYWORDS*`), więc ten też trzeba odświeżyć.
 */
export const useSetBrandLabel = (projectId: number, options?: { onError?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: BrandLabelRequest) => setBrandLabel(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_PROJECT_KEYWORDS, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_COMMON_KEYWORDS, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_ALL_COMMON_KEYWORDS, projectId] });
    },
    onError: () => options?.onError?.(),
  });
};
